import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["showDoc", "editDoc", "input"];

  edit(event) {
    event.preventDefault();
    this.showDocTarget.classList.add("d-none");
    this.editDocTarget.classList.remove("d-none");
    this.inputTarget.focus();
  }

  cancel(event) {
    event.preventDefault();
    this.editDocTarget.classList.add("d-none");
    this.showDocTarget.classList.remove("d-none");
  }

  save(event) {
    event.preventDefault();
    var url = this.element.dataset.editDocumentNameUrlValue;
    var name = this.inputTarget.value;

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": localStorage.getItem("bp-x-csrf-token"),
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
      body: JSON.stringify({ name: name }),
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.success) {
          var displayName = name || this.showDocTarget.dataset.filename;
          this.showDocTarget.querySelector(".name").textContent = displayName;
          this.editDocTarget.classList.add("d-none");
          this.showDocTarget.classList.remove("d-none");
          window.notyf.success(data.message);
        } else {
          window.notyf.error(data.message);
        }
      }.bind(this))
      .catch(function () {
        window.notyf.error("Something went wrong. Please try again.");
      });
  }
}
